import React from 'react';
import { ModuleType } from '../types';
import { ArticleModule as FrodorArticleModule } from '@spotify-internal/frodor-modules';
import { useShareButtonsCopy } from '../../ui/copy';
import { useCurrentPageUrl } from '../utils';

export type ArticleModuleType = ModuleType & {
  introduction?: string;
  body?: string;
  initialDropcap?: boolean;
  copy?: {
    share: string;
    shareTitle: string;
    facebookShareLabel: string;
    twitterShareLabel: string;
    copyLinkLabel: string;
  };
  shareUrl?: string;
};

export const ArticleModule: React.FC<ArticleModuleType> = ({
  introduction = '',
  body = '',
  initialDropcap = false,
  copy,
  shareUrl,
}) => {
  const shareButtonsCopy = useShareButtonsCopy();
  const currentPageUrl = useCurrentPageUrl(shareUrl);

  return (
    <FrodorArticleModule
      contentType="articleModule"
      body={body}
      introduction={introduction}
      initialDropcap={initialDropcap}
      copy={copy || shareButtonsCopy}
      shareUrl={currentPageUrl}
    />
  );
};
